(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/payfooter-selfservice.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/payfooter-selfservice.js');

'use strict';

const closeTimeDescription = closeTime => {
  if (!closeTime) {
    return '';
  }
  const date = new Date(closeTime);
  const time = dateFns.format(date, 'HH:mm', {
    locale: dateFns.locales.sv
  });
  let day;
  switch (true) {
    case dateFns.isToday(date):
      day = 'idag';
      break;
    case dateFns.isTomorrow(date):
      day = 'imorgon';
      break;
    case Math.abs(dateFns.differenceInDays(date, new Date())) > 6:
      day = dateFns.format(date, 'd/M', {
        locale: dateFns.locales.sv
      });
      break;
    default:
      day = dateFns.format(date, 'EEEE', {
        locale: dateFns.locales.sv
      });
  }
  return "Spelstopp: ".concat(day, " ").concat(time);
};
svs.numbergames.game.views.PayFooterSelfservice = Marionette.View.extend({
  cartIsAddable: false,
  modelEvents: {
    'change:isValid': 'updatePayfooterText',
    'change:selectedPackage': 'packageChanged'
  },
  ui: {
    payfooter: '.js-payfooter'
  },
  behaviors() {
    return [{
      behaviorClass: svs.numbergames.game.behaviors.Payfooter,
      shouldShowSum: () => false,
      payButtonTitle: () => this.cartIsAddable ? 'Lägg till i varukorg ({amount} kr)' : '({amount} kr)',
      payButtonTitleDisabled: () => "(".concat(this.model.get('price'), " kr)"),
      reminderOptions: () => ({
        intersectionOptions: {
          rootMargin: '0px 0px -168px 0px'
        }
      }),
      analyticsEvents: this.getOption('analyticsEvents')
    }];
  },
  initialize() {
    svs.numbergames.game.logger.debug('PayFooter initialize', this);
    this.setupScroll();

    let intervalCount = 0;
    const interval = setInterval(() => {
      intervalCount++;
      if (svs.components.selfserviceCart && svs.components.selfserviceCart.getCartInstance) {
        clearInterval(interval);
        svs.numbergames.game.logger.info("Selfservice cart loaded within ".concat(intervalCount * 200, " ms"));
        this.setCartGameCallback();
      }
    }, 200);
    setTimeout(() => {
      clearInterval(interval);
      if (!svs.components.selfserviceCart || !svs.components.selfserviceCart.getCartInstance) {
        svs.numbergames.game.logger.warn('Selfservice cart still not available one second after view initialize');
      }
    }, 1000);
  },
  onAttach() {
    setTimeout(() => {
      this.handleScroll();
    }, 200);
  },
  setCartGameCallback() {
    svs.components.selfserviceCart.getCartInstance().setGameCallback(() => {
      if (this.model.get('isValid')) {
        return svs.components.selfserviceCart.constants.GAMECALLBACK_HASCOMPLETEGAME;
      } else if (this.model.get('boards').findWhere({
        isEmpty: false
      })) {
        return svs.components.selfserviceCart.constants.GAMECALLBACK_HASINCOMPLETEGAME;
      }
      return svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME;
    });
  },
  updatePayfooterText() {
    this.triggerMethod('updatePayfooterText');
  },
  updatePaybutton() {
    this.triggerMethod('updatePayButtonTitle');
    this.triggerMethod('updatePayfooterSum');
  },
  setupScroll() {
    this.boundHandleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.boundHandleScroll);
  },
  handleScroll() {
    var _document$getElementB, _this$getUI;
    const previousEl = (_document$getElementB = document.getElementById('ngPayfooterRegion')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.previousElementSibling;
    const payfooterEl = (_this$getUI = this.getUI('payfooter')) === null || _this$getUI === void 0 ? void 0 : _this$getUI[0];
    const pageContentViewed = (payfooterEl === null || payfooterEl === void 0 ? void 0 : payfooterEl.getBoundingClientRect().top) > (previousEl === null || previousEl === void 0 ? void 0 : previousEl.getBoundingClientRect().bottom) - 24;

    if (!this.cartIsAddable && pageContentViewed || !payfooterEl || !previousEl) {
      this.cartIsAddable = true;
      this.updatePaybutton();
      window.removeEventListener('scroll', this.boundHandleScroll);
    }
  },
  scrollToPageBottom() {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  },
  packageChanged() {
    this.cartIsAddable = false;
    this.updatePaybutton();
    this.setupScroll();
    this.handleScroll();
  },
  onPay() {
    svs.numbergames.game.logger.debug('User wants to pay');
    if (!this.cartIsAddable) {
      this.scrollToPageBottom();
      return;
    }
    const selfserviceWager = this.model.toAPIJSON();
    const productId = this.model.get('productId');
    const selectedDays = this.model.get('selectedDays');
    let closeTime;
    if (svs.numbergames.productMapping.isVikinglotto(productId) && this.model.get('hasJoker')) {
      closeTime = svs.numbergames.game.draw.jokerCloseTime;
    } else if (svs.numbergames.productMapping.isProductFamily(productId)) {
      const firstDraw = svs.numbergames.game.draw.upcomingDrawProduct;
      if (selectedDays.length > 1) {
        closeTime = svs.numbergames.game.draw[firstDraw].closeTime;
      } else {
        closeTime = svs.numbergames.game.draw[selectedDays[0]].closeTime;
      }
    } else {
      closeTime = svs.numbergames.game.draw.closeTime;
    }
    const productProperties = {
      wagers: selfserviceWager,
      isLive: false,
      headers: {
        source: 'SvS:TB:ITS'
      },
      productFlag: productId,
      productTitle: svs.numbergames.productMapping.getProductName(productId),
      cost: this.model.get('price'),
      description: closeTimeDescription(closeTime)
    };
    const wagerWrapper = svs.components.selfserviceCart.generateProductItem(productProperties);
    svs.components.selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
      if (!err) {
        this.model.removeFromLocalStorage(() => {
          setTimeout(() => svs.utils.url.navigate(svs.core.urlMapping.get('startPage')), 300);
        });
      }
    });
  },
  onDestroy() {
    window.removeEventListener('scroll', this.boundHandleScroll);
  }
});

 })(window);